import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Check, TrendingUp } from 'lucide-react';
import { packages } from '../data/staticData';
import { toast } from 'sonner';

const Packages = () => {
  const handleSelectPackage = (pkg) => {
    console.log('Selected package:', pkg.name);
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      toast.success(`${pkg.name} selected!`, {
        description: 'Please fill out the contact form below.'
      });
    }
  };

  return (
    <section id="packages" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="bg-amber-100 text-amber-700 hover:bg-amber-200 mb-4">
            Tour Packages
          </Badge>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Curated Travel Experiences
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Choose the perfect package tailored to your travel dreams
          </p>
        </div>

        {/* Packages Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {packages.map((pkg) => (
            <Card
              key={pkg.id}
              className={`relative overflow-hidden border-2 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 ${
                pkg.popular
                  ? 'border-[#ef571b] shadow-xl'
                  : 'border-gray-200 hover:border-[#ce9b42]'
              }`}
            >
              {/* Popular Badge */}
              {pkg.popular && (
                <div className="absolute top-4 right-4 z-10">
                  <Badge className="bg-gradient-to-r from-amber-400 to-orange-500 text-white border-0 shadow-lg">
                    <TrendingUp className="h-3 w-3 mr-1" />
                    Popular
                  </Badge>
                </div>
              )}

              <CardHeader className="bg-gradient-to-br from-[#e4e2de] to-[#b0cd83]/20 pb-8">
                <CardTitle className="text-2xl font-bold text-gray-900 mb-2">
                  {pkg.name}
                </CardTitle>
                <p className="text-gray-600 text-sm">{pkg.description}</p>
                
                {/* Price */}
                <div className="mt-6">
                  <div className="flex items-baseline">
                    <span className="text-4xl font-bold text-[#ef571b]">
                      ${Number(pkg.starting_price || pkg.startingPrice).toLocaleString()}
                    </span>
                    <span className="text-gray-500 ml-2">/ person</span>
                  </div>
                  <p className="text-sm text-gray-500 mt-1">Starting price</p>
                </div>
              </CardHeader>

              <CardContent className="pt-6">
                {/* Features List */}
                <ul className="space-y-3 mb-6">
                  {pkg.features.map((feature, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <div className="bg-[#b0cd83]/30 rounded-full p-1 mt-0.5">
                        <Check className="h-3 w-3 text-[#5c856e]" />
                      </div>
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <Button
                  onClick={() => handleSelectPackage(pkg)}
                  className={`w-full ${
                    pkg.popular
                      ? 'bg-[#ef571b] hover:bg-[#d84915] text-white shadow-lg'
                      : 'bg-white border-2 border-[#ef571b] text-[#ef571b] hover:bg-[#e4e2de]'
                  }`}
                >
                  Select Package
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Packages;